import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MarineInsuranceModel } from '@data-layer/models/marine-insurance';
import { PaymentBillItemPendingModel } from '@data-layer/models/payments';
import { IsfModel } from '@data-layer/models/isf';
import { EntrySummaryModel } from '@data-layer/models/entry-summaries';
import { LCLShipmentModel } from '@data-layer/models/lcl';
import { enumPaymentState } from '@data-layer/enums/payments';

@Component({
  selector: 'app-marine-insurance-quote-pricing-card',
  templateUrl: './marine-insurance-quote-pricing-card.component.html',
  styleUrls: ['./marine-insurance-quote-pricing-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarineInsuranceQuotePricingCardComponent {
  @Input() public marineInsurance: MarineInsuranceModel;
  @Input() public pendingBills: PaymentBillItemPendingModel;
  @Input() public parent: IsfModel | EntrySummaryModel | LCLShipmentModel;
  @Input() public isWithMarginTop: boolean;
  @Input() public isDisabled: boolean;

  @Output() public edit: EventEmitter<void> = new EventEmitter<void>();

  public isShowTerms: boolean;

  public showTerms(): void {
    this.isShowTerms = true;
  }

  public hideTerms(): void {
    this.isShowTerms = false;
  }

  public get disabled(): boolean {
    return this.marineInsurance?.isProviderWasDown || this.isDisabled || this.isPaymentPending;
  }

  public get headerText(): string {
    return 'LETS_GET_GOODS_COVERED';
  }

  public get isPaymentPending(): boolean {
    return this.marineInsurance?.paymentState === enumPaymentState.PENDING;
  }
}
